import { ServiceType } from 'favoriteList/constants/favoriteLists';

import styles from './providerPrice.module.scss';

type PriceContainerProps = {
  lowestPrice: number | null;
  lowestPriceNoTax: number | null;
  lowestPriceDescription: string;
  serviceType: ServiceType;
};

const ProviderPrice = ({
  lowestPrice,
  lowestPriceNoTax,
  lowestPriceDescription,
  serviceType,
}: PriceContainerProps) => {
  const formatLowestPriceNoTax = lowestPriceNoTax
    ? new Intl.NumberFormat('ja-JP').format(lowestPriceNoTax)
    : '';
  const formatLowestPrice = lowestPrice ? new Intl.NumberFormat('ja-JP').format(lowestPrice) : '';

  const isDomestic = serviceType === ServiceType.DOMESTIC;

  const priceToCheck = isDomestic ? lowestPriceNoTax : lowestPrice;

  return (
    <div className={styles.priceContainer}>
      {priceToCheck && priceToCheck > 0 ? (
        <>
          <div className={styles.priceArea}>
            <div className={styles.priceYen}>最安値</div>
            <div className={styles.lowestPrice}>
              {isDomestic ? formatLowestPriceNoTax : formatLowestPrice}
            </div>
            <div className={styles.priceYen}>円〜</div>
          </div>
          {isDomestic && <div className={styles.noteArea}>{lowestPriceDescription}</div>}
        </>
      ) : null}
    </div>
  );
};

export default ProviderPrice;
